<template>
  <n-modal
    class="publish_modal"
    :show-icon="false"
    :style="{ width: '540px' }"
    :show="feedbackShowModal"
    :mask-closable="false"
    title="Thanks For Your Feedback"
    preset="dialog"
    @close="handleCancelModalClick"
  >
    <template #default>
      <div class="modal_content">
        <n-form
          ref="formRef"
          :model="model"
          :rules="rules"
          :label-width="120"
          label-placement="left"
          require-mark-placement="left"
          label-align="left"
        >
          <n-form-item label="Title" path="title">
            <n-input v-model:value="model.title" placeholder="Please Enter the Title" />
          </n-form-item>
          <n-form-item label="Menu" path="model">
            <n-tree-select
              ref="treeSelect"
              v-model:value="model.model"
              key-field="label"
              placeholder="Please Select the Menu"
              :show-path="true"
              :options="modelMenu"
            ></n-tree-select>
          </n-form-item>
          <n-form-item label="Description" path="content">
            <n-input v-model:value="model.content" type="textarea" placeholder="Please Enter the Description" />
          </n-form-item>
          <n-form-item label="Upload" path="upload">
            <n-upload
              :action="baseApiUrl + 'feedback/file/upload'"
              list-type="image-card"
              :multiple="false"
              name="files"
              :headers="{
                'X-Token': token,
              }"
              @change="changeFileList"
              @finish="finishFile"
            >
            </n-upload>
          </n-form-item>
        </n-form>
      </div>
    </template>
    <template #action>
      <div class="center_action">
        <n-space>
          <save-btn @click="handleCancelModalClick"> Cancel </save-btn>
          <save-btn type="primary" :loading="feedbackSubmitStatus" @click="handleAddModalClick"> Submit </save-btn>
        </n-space>
      </div>
    </template>
  </n-modal>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { NSpace, NModal, NForm, NFormItem, NInput, NTreeSelect, NUpload, FormInst } from 'naive-ui';

import { SaveBtn } from '@/components/button/index';
import { addFeedback, getMenuOptions } from '@/api/feedback';

import type { UploadFileInfo } from 'naive-ui';

const baseApiUrl: string | undefined = import.meta.env.VITE_GLOB_API_URL;

const store = useStore();

let token = store.getters.token;
const rules = {
  title: {
    required: true,
    trigger: ['blur', 'input'],
    message: 'Please Input Title',
  },
  model: {
    required: true,
    trigger: ['blur', 'input'],
    message: 'Please Input Model',
  },
  content: {
    required: true,
    trigger: ['blur', 'input'],
    message: 'Please Input Content',
  },
};
defineProps({
  feedbackShowModal: {
    type: Boolean,
    default: false,
  },

  status: {
    type: String,
    default: '',
  },
});
const model = ref({
  title: '',
  model: null,
  content: '',
  picurl: '',
});
const modelMenu = ref([]);
const treeSelect = ref(null);
const formRef = ref<FormInst | null>(null);
const uploadFileList = ref<any[]>([]);
const feedbackSubmitStatus = ref(false);
onMounted(() => {
  fetchGetMenuOptions();
});

const fetchGetMenuOptions = () => {
  getMenuOptions().then((res) => {
    modelMenu.value = res;
  });
};

const $emits = defineEmits(['update:feedbackShowModal', 'handNegativeUpdate']);

const handleCancelModalClick = () => {
  $emits('update:feedbackShowModal', false);
  model.value = {
    title: '',
    model: null,
    content: '',
    picurl: '',
  };
};
const handleAddModalClick = () => {
  formRef.value?.validate((errors: any) => {
    if (!errors) {
      feedbackSubmitStatus.value = true;
      const treeSelectValue: any | null = treeSelect.value;
      const { label } = treeSelectValue.selectedOption;
      addFeedback({
        ...model.value,
        model: label,
        picurl: uploadFileList.value.map((item: any) => item.name),
      }).then(() => {
        feedbackSubmitStatus.value = false;
        window.$message.success('Thanks For Your Feedback');
        handleCancelModalClick();
      });
    } else {
      model.value = {
        title: '',
        model: null,
        content: '',
        picurl: '',
      };
    }
  });
};

const finishFile = ({ file, event }: { file: UploadFileInfo; event?: any }) => {
  const {
    currentTarget: { response },
  } = event;
  const jsonResponse = JSON.parse(response);
  const { data } = jsonResponse;
  file.name = data[0];
  return file;
};
const changeFileList = ({ file, fileList }: { file: UploadFileInfo; fileList: Array<UploadFileInfo> }) => {
  uploadFileList.value = fileList.filter((item) => item.status === 'finished');
};
</script>

<style lang="scss" scoped>
.close_ipt {
  width: 400px;
}

.modal_content {
  padding-left: 5px;
}

.n-steps .n-step {
  min-height: 50px;
  padding-bottom: 0;
}
</style>
<style lang="scss">
.publish_modal .n-step-content__description {
  font-size: 14px;
}
</style>
